<div class="title">Products</div>
<app-reporting-table [loading]="loading()" [rows]="rows()" [columns]="columns()">
	<!-- Header templates (defines order/keys) -->
	<ng-template appHeaderColumn="productName">Product</ng-template>
	<ng-template appHeaderColumn="locationCount">Schools</ng-template>
	<ng-template appHeaderColumn="teacherCount">Teachers</ng-template>
	<ng-template appHeaderColumn="sectionCount">Classes</ng-template>
	<ng-template appHeaderColumn="studentCount">Students</ng-template>

	<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
	<ng-template appRowColumn="productName" let-row>
		<div class="name-column" (click)="onRowClick(row)">{{ row.productName }}</div>
	</ng-template>
	<ng-template appRowColumn="locationCount" let-row>{{ row.locationCount | number }}</ng-template>
	<ng-template appRowColumn="teacherCount" let-row>{{ row.teacherCount | number }}</ng-template>
	<ng-template appRowColumn="sectionCount" let-row>{{ row.sectionCount | number }}</ng-template>
	<ng-template appRowColumn="studentCount" let-row>{{ row.studentCount | number }}</ng-template>
</app-reporting-table>
